import CustomerDashboard from '../../components/customer/dashboard/CustomerDashboard'

const CustomerHome = () => {
    return <CustomerDashboard />
}

export default CustomerHome
